export const subscriptionSetupDetailsData = [
    { 
        title: 'Create Subscription Plans', 
        content: 'Create membership subscription plans for your community and get paid.',
    },
];
